export const platformView = () => {
	return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
